// Placeholder API fetchers for each entity type
// Replace URLs and params with actual API endpoints when available

export const fetchAuthorsByAlpha = async (alpha) => {
  const res = await fetch(`https://live.jeyaagency.com/api/alpha-entity?type=author${alpha ? `&alpha=${encodeURIComponent(alpha)}` : ''}`);
  const data = await res.json();
  // Return [{ id, name }]
  return Array.isArray(data.data) ? data.data.map(a => ({ id: a.id, name: a.name })) : [];
};

export const fetchPublishersByAlpha = async (alpha) => {
  const res = await fetch(`https://live.jeyaagency.com/api/alpha-entity?type=publisher${alpha ? `&alpha=${encodeURIComponent(alpha)}` : ''}`);
  const data = await res.json();
  // Return [{ id, name }]
  return Array.isArray(data.data) ? data.data.map(p => ({ id: p.id, name: p.name })) : [];
};

export const fetchDepartmentsByAlpha = async (alpha) => {
  const res = await fetch(`https://live.jeyaagency.com/api/alpha-entity?type=department${alpha ? `&alpha=${encodeURIComponent(alpha)}` : ''}`);
  const data = await res.json();
  // Return [{ id, department }]
  return Array.isArray(data.data) ? data.data.map(d => ({ id: d.id, department: d.department })) : [];
};

export const fetchCategoriesByAlpha = async (alpha) => {
  const res = await fetch(`https://live.jeyaagency.com/api/alpha-entity?type=category${alpha ? `&alpha=${encodeURIComponent(alpha)}` : ''}`);
  const data = await res.json();
  // Return [{ id, name }]
  return Array.isArray(data.data) ? data.data.map(c => ({ id: c.id, name: c.name })) : [];
};
